export const imageBrowserCloseEvent = 'image-browser-close-event';

export interface ImageBrowserCloseEventDetail {
	image: string;
}
